<template>
  <!-- 大会员打卡0元购 -->
  <div
    class="sign"
    id="sign"
    v-pageBuried
    :data-page-buried="'BG_VIP_HD_0YDK_GMDK_' + (activityId + 1)"
  >
    <div class="container">
      <img
        class="bg-image"
        :src="
          signInfo &&
          signInfo.activity_info &&
          signInfo.activity_info.cover_image
        "
        alt=""
      />
      <div class="back-container">
        <AppNavBar
          :placeholder="true"
          :options="options"
          :back="false"
          :showTabBar="false"
        ></AppNavBar>
        <div class="back-wrapper">
          <div class="back" @click="bindBack"
            ><span class="iconfont icon-fanhui"></span
          ></div>
          <div class="btn-list">
            <div class="btn-item" @click="bindShowRule"><span>规则</span></div>
            <div class="btn-item" @click="bindToRecord"><span>记录</span></div>
          </div>
        </div>
      </div>
      <div class="wrapper">
        <div class="top">
          <div v-if="signInfo">
            <SignContent
              ref="sign"
              @sign="bindSign"
              :activityId="activityId"
              @success="bindSuccess"
              @error="bindError"
              :data="signInfo"
            />
            <TaskContent
              :data="taskData"
              :status="signInfo && signInfo.user_plan_state"
              :activityId="activityId"
              @task="bindClickItem"
              :type="2"
            />
            <ReservationComponent
              :signInfo="signInfo"
              :activityId="activityId"
            />
            <VipRight :signInfo="signInfo" :activityId="activityId" />
          </div>
          <TipComponent class="tips-content" />
          <RuleComponent />
        </div>
        <img
          class="logo"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9bd932ce629eec7250a2c1b5691a1031.png"
          alt=""
        />
      </div>
    </div>
    <!-- 弹框 -->
    <van-overlay :show="showToast" @click="showToast = false" z-index="2000">
      <div class="toast-wrapper animate__animated animate__bounceIn">
        <NotQualificationToast v-if="showToast" @confirm="bindConfirm" />
      </div>
    </van-overlay>
    <!-- 首次提醒弹框 -->
    <van-overlay
      :show="showFirstToast"
      @click="showFirstToast = false"
      z-index="2000"
    >
      <div class="toast-wrapper animate__animated animate__bounceIn">
        <FirstTipsToast @confirm="bindConfirmFirst" @cancel="bindCancelFirst" />
      </div>
    </van-overlay>
    <!--  -->
  </div>
</template>
<script>
import AppNavBar from '@/components/app/nav-bar/index.vue'
import SignContent from './sign.vue'
import TaskContent from './task.vue'
import NotQualificationToast from './not-qualification-toast.vue'
import FirstTipsToast from './first-tips-toast.vue'
import NoticeComponent from './notice-component.vue'
import PrizeComponent from './prize.vue'
import RuleComponent from './rule.vue'
import TipComponent from './tip.vue'
import ReservationComponent from './reservation.vue'
import VipRight from './vip-right.vue'
export default {
  name: 'user-sign-vip',
  components: {
    SignContent,
    TaskContent,
    NotQualificationToast,
    NoticeComponent,
    PrizeComponent,
    RuleComponent,
    AppNavBar,
    FirstTipsToast,
    TipComponent,
    ReservationComponent,
    VipRight
  },
  props: {
    activityId: {
      type: Number,
      default: 2
    },
    signInfo: {
      type: Object,
      default: null
    },
    taskData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      options: { barBackgroundColor: 'rgba(0,0,0,0)' },
      toastType: 1,
      showToast: false,
      showFirstToast: false
    }
  },
  created() {},
  methods: {
    bindSuccess() {
      this.$betterwe.jumpRoute(
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252Fcdf8beff4a846f395a41ae119b80713d.jpg'
      )
    },
    bindError() {
      this.$betterwe.jumpRoute(
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F234e7d73762bd839f588db8db7d6de4e.webp'
      )
    },
    bindShowRule() {
      let el = document.getElementById('activity-rule')
      el?.scrollIntoView()
    },
    bindBack() {
      this.$http.appBack()
    },
    bindConfirm() {
      this.showToast = false
      this.$betterwe.vipHomePage()
    },
    bindSign() {
      this.$betterwe.isLogin(this.loginCallback)
    },
    loginCallback() {
      this.activityQualification(this.bindClickClock)
    },
    bindCancelFirst() {
      this.showFirstToast = false
    },
    /* 判断资格，如果有资格则执行回调函数 */
    async activityQualification(calback, ...params) {
      if (this.signInfo.user_plan_state == 0) {
        let isQualification = await this.getHasQualification()
        if (!isQualification) {
          this.showToast = true
        } else {
          this.toastConfirmCallBack = calback
          this.toastConfirmParams = params
          this.showFirstToast = true
        }
      } else if (this.signInfo.user_plan_state == 3) {
        calback(...params)
      }
    },
    async bindConfirmFirst() {
      this.showFirstToast = false
      let res = await this.initQualification()
      if (res) {
        this.toastConfirmCallBack(...this.toastConfirmParams)
      }
    },
    /* 去打卡 */
    async bindClickClock() {
      let res = await this.$http
        .getBaseApp('api/v1/UserCenter/getUserProfile', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (!res.data.is_app_weight_goal) {
            this.$betterwe.jumpRoute('/userProfileInputSex?pageType=1')
          } else {
            this.jumpClock()
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    jumpClock() {
      for (let item of this.taskData) {
        if (item.plan_id == 5) {
          this.$betterwe.jumpRoute(item.jump_url)
          return
        }
      }
      this.$toast('未找到任务')
    },
    bindToPrizePage() {
      this.$router.push('/user-sign/prize-list')
    },
    signApi() {
      this.$http
        .postAppWithAppInfo('api/v1/SignActivity/signIn', {
          activity_id: this.activityId
        })
        .then((res) => {
          res = res.data
        })
        .catch(() => {})
    },
    /* 获取是否有资格 */
    async getHasQualification() {
      let res = await this.$http.getAppWithAppInfo(
        'api/v1/SignActivity/checkPrivilege',
        { activity_id: this.activityId }
      )
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data) {
            return !!res.data.can_participate
          }
        }
      }
    },
    /* 初始化开始挑战 */
    async initQualification() {
      return new Promise(async (resolve, reject) => {
        let res = await this.$http
          .getAppWithAppInfo('api/v1/SignActivity/zeroBuyStart', {
            activity_id: this.activityId
          })
          .catch(() => {
            reject(false)
          })
        if (res) {
          res = res.data
          if (res.code == 200) {
            resolve(true)
          } else {
            this.$toast(res.msg)
            reject(false)
          }
        }
      })
    },
    async completeTask(id) {
      let res = await this.$http
        .postApp('api/v1/Vote/completePlan', {
          plan_id: id,
          activity_id: this.activityId
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$parent?.getTaskInfo()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async bindClickItem(item) {
      this.activityQualification(this.bindToCompleteTask, item)
    },
    bindToCompleteTask(item) {
      /* 如果任务锁定了 */
      if (item.is_lock) {
        let relateTask = this.taskData.find((item1) => {
          return item1.id == item.relate_plan_id
        })
        if (relateTask) {
          this.$toast('请先完成第一个任务“' + relateTask.name + '”')
        } else {
          this.$toast('前置解锁任务不存在')
        }
        return
      }
      if (!item.plan_state) {
        //未完成
        switch (item.complete_type) {
          case 1:
            /* 点击即可完成 */
            this.completeTask(item.plan_id)
            this.$betterwe.jumpRoute(item.jump_url)
            break
          case 2:
            this.$betterwe.jumpRoute(item.jump_url)
            break
        }
      }
    },
    bindToRecord() {
      this.$router.push({
        path: '/activity/member-sign-in/record',
        query: {
          activityId: this.activityId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.sign {
  .back-container {
    position: fixed;
    z-index: 2;
    width: 100%;
    top: 0;
    left: 0;
  }

  .container {
    position: relative;
    overflow: hidden;
    min-height: 100vh;
    background: #f96830;
    .bg-image {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
    .back {
      z-index: 999;
      position: absolute;
      left: 14px;
      top: 20px;
      width: 30px;
      height: 30px;
      background: rgba(0, 0, 0, 0.16);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .iconfont {
        color: #fff;
        font-size: 18px;
      }
    }

    .back-wrapper {
      position: relative;
    }

    .btn-list {
      z-index: 999;
      position: absolute;
      right: 14px;
      top: 20px;
      display: flex;
      flex-direction: column;

      .btn-item {
        margin-bottom: 12px;
        width: 30px;
        height: 30px;
        background: rgba(0, 0, 0, 0.16);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 20px;

        .iconfont {
          font-size: 14px;
          font-weight: 700;
        }
      }
    }

    .activity-time {
      position: absolute;
      left: 0;
      top: 86px;

      .time-image {
        width: 134px;
        height: 61px;
      }

      .time-duration {
        font-family: PingFangSC, PingFang SC;
        padding: 0px 6px;
        font-weight: bold;
        font-size: 14px;
        height: 28px;
        line-height: 28px;
        position: absolute;
        transform: rotate(-5deg);
        top: 33px;
        left: 0;
      }
    }

    .wrapper {
      margin-top: 570px;
      .top {
        position: relative;
        margin-bottom: 27px;

        .notice-component {
          position: absolute;
          position: absolute;
          left: 0px;
          top: -46px;
          width: 100%;
          padding: 0px 14px;
          box-sizing: border-box;
          height: 40px;
          z-index: 999;
          overflow: hidden;
        }

        .prize-user-container {
          width: 100%;
          height: 40px;
          position: absolute;
          left: 0px;
          top: -46px;

          .prize-user-overflow {
            height: 100%;
            overflow: hidden;
          }

          .prize-user-content {
            height: 26px;

            ::v-deep .van-notice-bar {
              height: 100%;
            }

            ::v-deep .van-notice-bar__wrap {
              overflow: visible;
            }

            ::v-deep .van-ellipsis {
              overflow: visible;
            }

            ::v-deep .van-swipe {
              overflow: visible;
            }
          }
        }

        .prize-user-swipe {
          height: 26px;

          .prize-user-item {
            display: inline-block;
            padding: 0px 7px;
            white-space: nowrap;
            height: 20px;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 10px;
            backdrop-filter: blur(6px);
            font-size: 10px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            color: #ffffff;
            line-height: 20px;
          }
        }

        .integral-content {
          height: 50px;
          display: flex;
          align-items: center;
          background: rgba(255, 255, 255, 0.93);
          box-shadow: 0px 5px 9px 0px rgba(75, 195, 156, 0.47);
          border-radius: 26px;
          border: 2px solid #ffffff;
          backdrop-filter: blur(9px);
          margin-bottom: 17px;
          position: relative;

          .mask {
            border-radius: 25px;
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            overflow: hidden;
          }

          .integral-dot-filter {
            position: absolute;
            width: 125px;
            height: 125px;
            background-color: #fff9cd;
            border-radius: 50%;
            filter: blur(36px);
            left: -46px;
            top: -90px;
          }

          .integral-item {
            position: relative;
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .integral-flag {
              position: absolute;
              left: 50%;
              top: 0;
              transform: translate(-50%, -90%);
              width: 104px;
              height: 22px;
              object-fit: contain;
            }

            .integral-icon {
              width: 20px;
              height: 20px;
              margin-right: 6px;
            }

            .integral-text {
              font-size: 18px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
              line-height: 25px;
            }

            .integral-num {
              position: relative;
              font-size: 26px;
              font-family: DIN, DIN;
              font-weight: bold;
              color: #ff6464;
              line-height: 31px;
              margin-right: 4px;
            }

            .iconfont {
              font-size: 18px;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.3);
            }
          }

          .integral-item-first::after {
            content: '';
            position: absolute;
            top: 50%;
            right: 0%;
            transform: translate(-50%, -50%);
            width: 1px;
            height: 16px;
            background-color: rgba(0, 0, 0, 0.12);
          }
        }
      }

      .logo {
        margin: 0 auto 80px;
        height: 16px;
      }
    }
  }
}

.toast-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.tips-content {
  margin-bottom: 40px;
}
</style>
